import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=b4dcde5a&scoped=true"
import script from "./search-box.vue?vue&type=script&lang=js"
export * from "./search-box.vue?vue&type=script&lang=js"
import style0 from "./search-box.vue?vue&type=style&index=0&id=b4dcde5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dcde5a",
  null
  
)

export default component.exports